import { api } from '../../../lib/api.js';

const DEFAULT_DOMAIN = 'english';

export async function fetchProctorDetails({ domain = DEFAULT_DOMAIN, courseId, orgId }) {
  const safeOrgId = orgId ?? 'null';
  const res = await api.request({
    url: `get_proctor_details/${domain}/${courseId}/${safeOrgId}`,
    method: 'GET',
  });
  return res.data;
}

export async function fetchProctorToken(payload) {
  const endpoint = import.meta.env.VITE_RP_TOKEN_ENDPOINT;
  if (!endpoint) return null;
  const res = await api.request({
    url: endpoint.replace(/^\/?v1\//, ''),
    method: 'POST',
    data: payload,
  });
  return res.data;
}
